// Query serializer used by most API clients; skips empty arrays entirely.
export const serializeQueryParams = (params?: Record<string, unknown>) => {
  if (!params) return ''

  const serializeQueryParamValue = (value: Exclude<unknown, null | undefined>): string => {
    if (value instanceof Date) return value.toISOString()

    if (typeof value === 'string') return value

    if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
      return value.toString()
    }

    if (typeof value === 'symbol' || typeof value === 'function') {
      return value.toString()
    }

    try {
      return JSON.stringify(value)
    } catch {
      // Fallback for values that can't be JSON-stringified (e.g. circular references).
      return Object.prototype.toString.call(value)
    }
  }

  const searchParams = new URLSearchParams()
  const appendValue = (key: string, value: unknown) => {
    if (value === undefined || value === null) return

    if (Array.isArray(value)) {
      value.forEach((child) => appendValue(key, child))
      return
    }

    searchParams.append(key, serializeQueryParamValue(value))
  }

  Object.entries(params).forEach(([key, value]) => appendValue(key, value))

  return searchParams.toString()
}
